import { Dialog, DialogPanel } from "@headlessui/react";

import { FC, PropsWithChildren } from "react";

interface StyledModalProps extends PropsWithChildren {
  open: boolean;
  handleClose: () => void;
  title?: string;
}

const StyledModal: FC<StyledModalProps> = ({ open, handleClose, title, children }) => {
  return (
    <Dialog open={open} onClose={handleClose} className="bg-black">
      <div className="fixed inset-0 bg-[#00000060]" aria-hidden="true" />
      <DialogPanel>
        <div className="fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center p-4">
          {/* <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center p-4"> */}
          <div className="flex flex-col gap-4 rounded-xl bg-white p-6">
            {title && (
              <h4 className="font-jakarta-sans border-b-[0.5px] border-gray-200 p-6 text-center text-xl font-semibold">
                {title}
              </h4>
            )}
            <div className="p-6">{children}</div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
};

export default StyledModal;
